module.exports = __webpack_public_path__ + "img/guide_title.6d659936.png";